<script>

import { mapActions } from 'vuex'
import Basic from "@/driver/pages/dialogs/contents/_RecycleFinalDisposalBasic.vue";
import RecycleFinalDisposalFlow from "@/driver/pages/dialogs/contents/_RecycleFinalDisposalFlow.vue";
import DataTableModal from "@/driver/pages/dialogs/_DataTableModal.vue";

export default {
  name: 'BulkRecycleFinalDisposalReportDialog',
  components: {
    DataTableModal,
    RecycleFinalDisposalFlow,
    Basic
  },
  mixins: [],
  props: {
    /**
     * ダイアログの表示/非表示
     * @default false
     */
    enableDialog: {
      type: Boolean,
      default: false,
    },
    /**
     * マニフェストIDの配列
     * @default []
     */
    manifestIds: {
      type: Array,
      default: () => [],
    },
    /**
     * レポートの種類
     * Managements: マニフェスト管理, Acceptance: 処分場受入
     * @default null
     */
    type: {
      type: String,
      default: null,
    },
    /**
     * 受注IDの配列
     * @default []
     */
    orderIds: {
      type: Array,
      default: () => [],
    },
    /**
     * マニフェスト(1次, 2次)
     */
    manifestLevel: {
      type: String,
      default: "first_manifest"
    },
  },
  data() {
    return {
      manifest: {
        final_disposal_standard_quantity_type: null,
        target_for_registration: true,
        pattern_id: null,
        pattern: null,
        disposer_location_name: null,
        disposer_id: null,
        disposer_location_code: null,
        first_level_method_detail_ids: null,

        manifest_recycle_disposal_reports: [],
      },
      finalDisposalSites: [],
      enablePrimaryManifestModal: false,
      primaryManifestHeaders: [
        { value: 'second_manifest_no', text: '2次マニフェスト番号' },
        { value: 'second_manifest_id', text: 'DXEマニ番号' },
        { value: 'primary_manifest_no', text: '1次マニフェスト番号' },
        { value: 'primary_manifest_id', text: 'DXEマニ番号' },
        { value: 'primary_manifest_type_name', text: 'マニフェスト区分' },
        { value: 'primary_manifest_collected_date', text: '引渡日' },
      ],
      primaryManifestResult: [],
    }
  },
  computed: {},
  watch: {
    enableDialog (newValue) {
      Object.assign(this.manifest, this.$options.data().manifest);
      // this.cannotSyncList = []
      this.$nextTick(() => this.$refs.bulkFinalDisposalReportValidator.reset())
      if (newValue) {
        this.setVariable()
      }
    },
  },
  created() {
  },
  methods: {

    /**
     * マニフェスト
     * 最終処分終了報告
     */
    ...mapActions('DriverManifestRecycleFinalDisposalReport', {
      fetchFinalDisposalReports: 'show',
      fetchNewReportForManifest: 'new',
      registerReportForManifest: 'create',
    }),

    /**
     * 処分場受入
     * 最終処分終了報告
     */
    ...mapActions('DriverOrderRecycleFinalDisposalReport', {
      fetchNewReportForOrder: 'new',
      registerReportForOrder: 'create',
    }),

    /**
     * 紐付く1次マニの自動連携チェック処理
     */
    ...mapActions("DriverManifestPrimaryManifestSyncCheck", {
      cheCheck: "create"
    }),

    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.$emit('cancelCallback')
    },
    /**
     * 登録ボタン クリックイベント
     */
    registerButtonClickEvent () {
      this.$refs.bulkFinalDisposalReportValidator.validate().then((result) => {
        if (result) {
          // 選択された複数マニフェストを同じ内容で更新
          if (this.type === "Managements") {
            if (this.manifestLevel === 'first_manifest') {
              this.registerManifests([]);
            } else if (this.manifestLevel === 'second_manifest') {
              this.checkAndRegisterSecondManifest();
            }
          } else {
            this.registerForAcceptances();
          }
        }
      })
    },

    /**
     * マニフェスト管理
     * 一括登録処理の実行
     */
    registerManifests (excludeIds = []) {
      let params = this._buildParams()
      this.registerReportForManifest({params: params}).then(() => {
        this.$emit('registerEvent')
      })
    },

    /**
     * 2次マニ
     * 登録前の1次マニへの自動連携チェック処理
     */
    checkAndRegisterSecondManifest () {
      this.cheCheck({ params: { manifest_ids: this.manifestIds }}).then((response) => {
        const result = response.result;
        const content = response.content;
        if (result.code === 'ok') {
          this.registerManifests([]);
        } else {
          this.primaryManifestResult = content.unsync_primary_manifests
          this.enablePrimaryManifestModal = true;
        }
      })
    },

    /**
     * 処分場受入
     * 一括登録処理の実行
     */
    registerForAcceptances () {
      const params = this._buildParams()
      this.registerReportForOrder({ params: params }).then(() => {
        this.$emit('registerEvent')
      })
    },

    /**
     * 初期データのロード
     * 再資源化対応の機能を使えるかのチェックを行うため
     * リクエストを行う。
     */
    setVariable () {
      this.fetchFinalDisposalReports({ params: { manifest_ids: this.manifestIds } }).then((content) => {
        const firstManifest = content.manifests[0];
        this.manifest.disposer_location_name = firstManifest.disposer_location_name;
        this.manifest.disposer_id = firstManifest.disposer_id;
        this.manifest.disposer_location_code = firstManifest.disposer_location_code;
        this.manifest.item_id = content.manifests.map(v => v.item_id);
        this.manifest.first_level_method_detail_ids = firstManifest.first_level_method_detail_ids;
        this.$refs.bulkBasic.reloadPatterns();
      })
      if (this.type === "Managements") {
        this.fetchNewReportForManifest().then(() => {
        }).catch(() => {
          this.closeButtonClickEvent();
        })
      } else {
        /** 受注発注の場合はorder単位でのマニフェスト絞込が必要 */
        this.fetchNewReportForOrder().then(() => {
        }).catch(() => {
          this.closeButtonClickEvent();
        })
      }
    },
    /**
     * 連携対象外マニフェストのダイアログ 閉じるボタンコールバック
     */
    dialogCloseCallback() {
      this.enablePrimaryManifestModal = false;
    },
    /**
     * 連携対象外マニフェストのダイアログ 実行ボタンコールバック
     */
    dialogRegisterCallback() {
      this.dialogCloseCallback();
      // 除外する1次マニフェストのIDを抽出
      // const excludes = this.cannotSyncList.map(item => item.primary_manifest_id)
      // this.registerManifests(excludes)
      this.registerManifests([])
      // this.syncDialogCloseButtonClickEvent();
    },
    /**
     * 登録パラメータの生成
     * @private
     */
    _buildParams () {
      const params = {
        manifest_ids: this.manifestIds,
        order_ids: this.orderIds,
        type: this.type,
        final_disposal_standard_quantity_type: this.manifest.final_disposal_standard_quantity_type,
        manifest_recycle_disposal_reports_attributes: []
      }
      for (let manifest_final_disposal of this.manifest.manifest_recycle_disposal_reports) {
        if (!manifest_final_disposal._destroy) {
          params.manifest_recycle_disposal_reports_attributes.push({
            level: manifest_final_disposal.level,
            recycle_disposer_disposal_method_id: manifest_final_disposal.recycle_disposer_disposal_method_id,
            recycle_disposer_disposal_method_detail_id: manifest_final_disposal.recycle_disposer_disposal_method_detail_id,
            before_disposal_weight: manifest_final_disposal.before_disposal_weight,
            after_disposal_weight: manifest_final_disposal.after_disposal_weight,
            before_disposal_ratio: manifest_final_disposal.before_disposal_ratio,
            after_disposal_ratio: manifest_final_disposal.after_disposal_ratio,
            sort_priority: manifest_final_disposal.sort_priority,
            final_disposal_date: manifest_final_disposal.final_disposal_date,
            final_disposal: manifest_final_disposal.final_disposal,
            comment: manifest_final_disposal.comment,

          })
        }
      }
      return params;
    },

  }
}
</script>
<template>
  <div>
    <v-dialog
      :value="enableDialog"
      persistent
      width="1700"
      scrollable
      @keydown.esc="closeButtonClickEvent"
      @close="closeButtonClickEvent"
    >
      <validation-observer ref="bulkFinalDisposalReportValidator">
        <v-card>
          <v-toolbar
            color="primary"
            dark
            flat
          >
            <v-toolbar-title>最終処分終了報告（一括登録）再資源</v-toolbar-title>
          </v-toolbar>
          <v-divider />
          <v-card-text style="max-height: 70vh; overflow-y: auto;">
            <v-row>
              <v-col cols="12" md="6">
                <basic
                  ref="bulkBasic"
                  :manifest.sync="manifest"
                  caller-type="bulk"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <recycle-final-disposal-flow
                  :manifest.sync="manifest"
                  caller-type="bulk"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn
              @click="closeButtonClickEvent"
            >
              閉じる
            </v-btn>
            <v-btn
              class="primary"
              @click="registerButtonClickEvent"
            >
              登録
            </v-btn>
          </v-card-actions>

        </v-card>
      </validation-observer>

      <data-table-modal
        :descriptions="['自動連携されないマニフェストがあります。', '対象の１次マニフェストは手動で最終処分終了報告を登録してください。']"
        :enable="enablePrimaryManifestModal"
        :headers="primaryManifestHeaders"
        :items="primaryManifestResult"
        positive
        positive-caption="継続して登録"
        @close="dialogCloseCallback"
        @positiveCallback="dialogRegisterCallback"
      />
    </v-dialog>
  </div>
</template>

